import { FilterDescriptor } from '@progress/kendo-data-query'
import { CompositeFilterDescriptor } from 'store/grid'
import { isString } from 'utils/is-string'
import { FilterSpecialCharactersPattern, isFilterDescriptor } from 'utils/QueryHelpers'

export const normalizeFilter = (filter: CompositeFilterDescriptor): CompositeFilterDescriptor => {
  const items = filter?.filters || []
  const filters = items.map((filterDescriptor: FilterDescriptor | CompositeFilterDescriptor) => {
    if (isFilterDescriptor(filterDescriptor) && isString(filterDescriptor?.value)) {
      return {
        ...filterDescriptor,
        value: filterDescriptor?.value?.replace(FilterSpecialCharactersPattern, ''),
      }
    }
    return filterDescriptor
  })
  return { ...filter, filters }
}

export const createFilterNormalizerWithMapping =
  (fieldMappings: { [key: string]: string }) =>
  (
    filterDescriptor: CompositeFilterDescriptor
  ): (CompositeFilterDescriptor | FilterDescriptor)[] => {
    const filters = normalizeFilterDescriptors(filterDescriptor)
    const { filters: filterDescriptors } = filters

    const result = filterDescriptors.map((x) => {
      if (isFilterDescriptor(x)) {
        const field = isString(x.field) && fieldMappings[x.field]
        if (field) {
          return {
            ...x,
            field,
            operator: '==',
            value: x?.value,
          }
        }
      }

      return x
    })

    return result
  }

const normalizeFilterDescriptors = (filterDescriptor: CompositeFilterDescriptor) => {
  const filters = filterDescriptor.filters
    .filter((filterItem: FilterDescriptor | CompositeFilterDescriptor) => {
      if (isFilterDescriptor(filterItem)) {
        return !!filterItem.value
      }
      return false
    })
    .map((x) => {
      if (isFilterDescriptor(x)) {
        return x
      }
      return x
    })

  return { ...filterDescriptor, filters }
}

export const mapAnyToNullInFilters = (
  filter: CompositeFilterDescriptor
): CompositeFilterDescriptor => {
  const items = filter?.filters || []
  const filters = items.map((filterDescriptor: FilterDescriptor | CompositeFilterDescriptor) => {
    if (isFilterDescriptor(filterDescriptor) && filterDescriptor?.value === 'Any') {
      return {
        ...filterDescriptor,
        value: null,
      }
    }
    return filterDescriptor
  })
  return { ...filter, filters }
}

export const resetOperatorOnFieldChange = (
  previous: CompositeFilterDescriptor | undefined,
  next: CompositeFilterDescriptor
): CompositeFilterDescriptor => {
  const prevFilters = previous?.filters || []
  const nextFilters = next?.filters || []

  const filters = nextFilters.map((filter, idx) => {
    const prevAtIdx = prevFilters[idx]

    if (isFilterDescriptor(filter)) {
      if (isFilterDescriptor(prevAtIdx) && prevAtIdx.field !== filter.field) {
        return { ...filter, operator: '==' }
      }
      return filter
    }

    const prevComposite = prevAtIdx && !isFilterDescriptor(prevAtIdx) ? prevAtIdx : undefined
    return resetOperatorOnFieldChange(prevComposite, filter)
  })

  return { ...next, filters }
}
